import React, { PropTypes } from 'react';
import classnames from 'classnames';

const RadioSelector = ({ className, defaultOption, disabled, onSelect, options, selectedOption }) => {
    let items = options.map(({ className, state }) =>
        <div
            key={ state }
            className={ classnames({ 'icon': true, selected: selectedOption === state, [className]: true}) }
            onClick={ () => !disabled && onSelect(state === selectedOption ? defaultOption : state) }
        ></div>);

    let classes = classnames({
        'radio-selector': true,
        [className]: true,
        disabled
    });
    return <div className={classes}>{ items }</div>;
};

RadioSelector.propTypes = {
    className: PropTypes.string,
    defaultOption: PropTypes.number,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string.isRequired,
        state: PropTypes.number.isRequired
    }).isRequired).isRequired,
    selectedOption: PropTypes.number
};
RadioSelector.defaultProps = {
    className: '',
    disabled: false
};

export default RadioSelector;


// WEBPACK FOOTER //
// ./src/components/radioselector/index.js